import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserRequiresPhoneVerification } from './user-requires-phone-verification.transformers';
import { UserRequiresPhoneVerificationCollection } from './user-requires-phone-verification.types';

export function userRequiresPhoneVerificationReducer(
  state: CollectionStateSlice<UserRequiresPhoneVerificationCollection> = {},
  action: CollectionActions<UserRequiresPhoneVerificationCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'userRequiresPhoneVerification') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserRequiresPhoneVerificationCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformUserRequiresPhoneVerification,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
